import React from 'react';
import { WithOptionalPermission, WithOptionalPermissionProps } from '../WithPermission';
import { NavDropdownItem as CommonNavDropdownItem, NavItemProps } from '@td-client-frontend/common';

export type NavDropdownItemProps = NavItemProps & WithOptionalPermissionProps;

export const NavDropdownItem = ({
  requiredPerms,
  mode,
  ...navDropdownItemProps
}: React.PropsWithChildren<NavDropdownItemProps>) => (
  <WithOptionalPermission requiredPerms={requiredPerms} mode={mode}>
    <CommonNavDropdownItem {...navDropdownItemProps} />
  </WithOptionalPermission>
);
